// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__4_CMK","inputWrap":"Table_inputWrap__p65px","col":"Table_col__SG22b","bmiTooltip":"Table_bmiTooltip__3rHiV"};